import { Box, Fade } from '@mui/material';
import { useNavigate } from 'react-router';

import { AppIcon, AppLogoIcon } from '@/modules/common/components/icons';
interface Props {
  drawerExpanded: boolean;
}

const DrawerHead = ({ drawerExpanded }: Props) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        height: '96px',
      }}
      onClick={() => navigate('/')}
    >
      <Fade in={!drawerExpanded}>
        <Box>
          <AppIcon className="w-9 translate-x-[30px] translate-y-[40px]" />
        </Box>
      </Fade>
      <Fade in={drawerExpanded}>
        <Box>
          <AppLogoIcon
            style={{
              width: '200px',
              height: 'auto',
              transform: 'translate(-2.9px, -19.5px) scale(0.675)',
            }}
          />
        </Box>
      </Fade>
    </Box>
  );
};

export default DrawerHead;
